module.exports = __webpack_public_path__ + "media/images/icons/icon_facebook-99c2e2fe6ba748e37ae253ca1708b4db.png";